import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { OpenContentDetailDialog } from '../../../actions/AppActionTypes';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { OpenContentDetailDialogAction } from '../../../actions/spaces/OpenContentDetailDialogActions';
import { ContentDetailsDialog } from '../../../content/contentDetailDialog/ContentDetailsDialog';

// Open Detail Dialog
export function* handleOpenContentDetailDialog(action: OpenContentDetailDialogAction) {
  try {
    yield call(ContentDetailsDialog.open, action.content, action.availableActions, action.location);
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function* rootContentDetailDialogSaga(): SagaIterator {
  yield takeLatest(OpenContentDetailDialog, handleOpenContentDetailDialog);
}
